// own instance of Object.entries with custom typings
const objectEntries = Object.entries as <T>(
  o: T,
) => [Extract<keyof T, string>, T[keyof T]][];

export default objectEntries;
